import { cx } from "@jugl-web/utils";
import { DraggableAttributes } from "@dnd-kit/core";
import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { ReactComponent as ReorderIcon } from "./assets/reorder.svg";

export const DragHandle: React.FC<{
  disabled?: boolean;
  dragHandleProps?: {
    attributes: DraggableAttributes;
    listeners: SyntheticListenerMap | undefined;
    setActivatorNodeRef: (element: HTMLElement | null) => void;
  };
}> = ({ disabled, dragHandleProps }) => (
  <div
    ref={!disabled ? dragHandleProps?.setActivatorNodeRef : undefined}
    className={cx(
      "mt-2 touch-none leading-0",
      disabled
        ? "cursor-not-allowed opacity-40"
        : "cursor-grab active:cursor-grabbing"
    )}
    {...(!disabled ? dragHandleProps?.attributes : {})}
    {...(!disabled ? dragHandleProps?.listeners : {})}
  >
    <ReorderIcon />
  </div>
);
